<div class="obr-page">

    <!-- Toolbar -->
    <div class="noPrint obr-toolbar">
        <div class="obr-toggle">
            <button type="button" [class.active]="!showDetails" (click)="showDetails = false">Briefly</button>
            <button type="button" [class.active]="showDetails" (click)="showDetails = true">In Details</button>
        </div>

        <label class="obr-search">
            <mat-icon>search</mat-icon>
            <input type="text" placeholder="Search ledger…" [(ngModel)]="searchTerm" [ngModelOptions]="{standalone: true}" />
        </label>

        <span class="obr-spacer"></span>

        <button type="button" class="obr-btn obr-btn-outline" printSectionId="print-section" ngxPrint [useExistingCss]="true">
            <mat-icon>print</mat-icon> Print
        </button>
        <button type="button" class="obr-btn obr-btn-solid" (click)="exportExcel('Expense-Opening-Balance-Report')">
            <mat-icon>download</mat-icon> Export
        </button>
        <button type="button" class="obr-btn obr-btn-ghost" mat-dialog-close>
            <mat-icon>close</mat-icon> Close
        </button>
    </div>

    <!-- Report -->
    <div id="print-section" class="obr-card">

        <!-- Header -->
        <div class="obr-header">
            <div class="obr-header-icon"><mat-icon>account_balance_wallet</mat-icon></div>
            <div class="obr-header-mid">
                <div class="obr-org-name">हिंदुस्थान प्रकाशन संस्था</div>
                <div class="obr-pub-name">विवेक साप्ताहिक</div>
                <div class="obr-report-title">Opening Balance Report</div>
            </div>
            <div class="obr-header-meta">
                <span>दिनांक : {{ getFormattedDate() }}</span>
                <span>दिनांक पासून : {{ startDate | date:'dd-MM-yyyy' }}</span>
                <span>दिनांक पर्यंत : {{ endDate   | date:'dd-MM-yyyy' }}</span>
            </div>
        </div>

        <!-- Stat tiles -->
        <div class="obr-tiles noPrint" *ngIf="!isLoading">
            <div class="obr-tile obr-tile-dr">
                <mat-icon>trending_down</mat-icon>
                <div>
                    <div class="obr-tile-label">Total Debit</div>
                    <div class="obr-tile-value">{{ grandTotalDR | number:'1.2-2' }}</div>
                </div>
            </div>
            <div class="obr-tile obr-tile-cr">
                <mat-icon>trending_up</mat-icon>
                <div>
                    <div class="obr-tile-label">Total Credit</div>
                    <div class="obr-tile-value">{{ grandTotalCR | number:'1.2-2' }}</div>
                </div>
            </div>
            <div class="obr-tile" [ngClass]="grandDifference === 0 ? 'obr-tile-ok' : 'obr-tile-warn'">
                <mat-icon>{{ grandDifference === 0 ? 'check_circle' : 'error_outline' }}</mat-icon>
                <div>
                    <div class="obr-tile-label">Difference</div>
                    <div class="obr-tile-value">{{ grandDifference | number:'1.2-2' }}</div>
                </div>
            </div>
            <div class="obr-tile obr-tile-count">
                <mat-icon>format_list_bulleted</mat-icon>
                <div>
                    <div class="obr-tile-label">Ledgers</div>
                    <div class="obr-tile-value">{{ groupedData.length }}</div>
                </div>
            </div>
        </div>

        <!-- Loading -->
        <div *ngIf="isLoading" class="obr-loading">
            <span class="obr-spinner"></span> Loading...
        </div>

        <ng-container *ngIf="!isLoading">

            <div class="obr-table-wrap">
                <table class="obr-table">
                    <thead>
                        <tr>
                            <th class="obr-w-sr">क्र.</th>
                            <th>तपशील</th>
                            <th class="text-right">डेबिट</th>
                            <th class="text-right">क्रेडिट</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let section of sections">

                        <!-- Section heading: Assets / Liabilities -->
                        <tr class="obr-section-row">
                            <td colspan="4">{{ section.label }}</td>
                        </tr>

                        <ng-container *ngFor="let group of section.groups; let i = index">

                            <!-- Main expense -->
                            <tr class="obr-main-row">
                                <td class="obr-sr">{{ i + 1 }}</td>
                                <td class="obr-name">{{ group.exp_name }}</td>
                                <td class="text-right">
                                    <span class="obr-amt obr-amt-dr" *ngIf="group.opening_bal_type === 'DR'">
                                        {{ group.opening_bal | number:'1.2-2' }}
                                    </span>
                                </td>
                                <td class="text-right">
                                    <span class="obr-amt obr-amt-cr" *ngIf="group.opening_bal_type === 'CR'">
                                        {{ group.opening_bal | number:'1.2-2' }}
                                    </span>
                                </td>
                            </tr>

                            <!-- Sub-expenses (Details mode only) -->
                            <ng-container *ngIf="showDetails">
                                <tr class="obr-sub-row" *ngFor="let sub of group.sub_expenses">
                                    <td></td>
                                    <td class="obr-sub-indent">→ {{ sub.sub_exp_name }}</td>
                                    <td class="text-right">
                                        <span class="obr-amt obr-amt-dr" *ngIf="sub.opening_bal_type === 'DR'">
                                            {{ sub.opening_bal | number:'1.2-2' }}
                                        </span>
                                    </td>
                                    <td class="text-right">
                                        <span class="obr-amt obr-amt-cr" *ngIf="sub.opening_bal_type === 'CR'">
                                            {{ sub.opening_bal | number:'1.2-2' }}
                                        </span>
                                    </td>
                                </tr>
                            </ng-container>

                        </ng-container>

                        <!-- Section subtotal -->
                        <tr class="obr-section-total-row">
                            <td></td>
                            <td>{{ section.label }} एकूण :-</td>
                            <td class="text-right">{{ section.totalDR | number:'1.2-2' }}</td>
                            <td class="text-right">{{ section.totalCR | number:'1.2-2' }}</td>
                        </tr>

                        </ng-container>

                        <tr *ngIf="!filteredGroups.length">
                            <td colspan="4" class="obr-empty">
                                <mat-icon>inbox</mat-icon>
                                <span>{{ groupedData.length ? 'No ledger matches your search' : 'No data found for this period' }}</span>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot *ngIf="filteredGroups.length">
                        <tr class="obr-total-row">
                            <td></td>
                            <td class="fw_600">एकूण :-</td>
                            <td class="text-right fw_600">{{ grandTotalDR | number:'1.2-2' }}</td>
                            <td class="text-right fw_600">{{ grandTotalCR | number:'1.2-2' }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>

        </ng-container>
    </div>
</div>
